(() => {
    "use strict"

    if (document.querySelector('[data-search]')) {
        const searchField = document.querySelector('[data-search-field]')
        const searchItems = document.querySelectorAll('[data-search-item]')
        const searchEmpty = document.querySelector('[data-search-empty]')

        searchField.addEventListener('input', evt => {
            const searchPhrase = evt.target.value.trim().toLowerCase()
            let visibleCount = 0

            searchItems.forEach(item => {
                const searchTerms = item.dataset.searchItem.split('|').map(term => term.trim().toLowerCase())
                const isMatch = searchPhrase === '' || searchTerms.some(term => term.includes(searchPhrase))

                item.style.display = isMatch ? '' : 'none'

                if (isMatch) {
                    visibleCount++
                }
            })

            if (searchEmpty) {
                searchEmpty.classList.toggle('active', visibleCount === 0)
            }
        })
    }
})()